import type { AuthenticationClient } from "@/lib/auth/authentication-client";

export async function getAuthorizationHeaders(
  authClient: AuthenticationClient,
): Promise<{ authorization: string }> {
  return {
    authorization: `Bearer ${await authClient.getTokenSilently()}`,
  };
}
